import * as types from '../../lib/constants';

const initialState = {
  lineups: {},
  matchInfo: {},
};

function reverseAwayTeam(lineups) {
  const reversedLineups = lineups;
  if (lineups && lineups.awayTeam && lineups.awayTeam.formationModule) {
    const reversedSchema = lineups.awayTeam.formationModule.reverse();
    Object.assign(reversedLineups.awayTeam.formationModule, reversedSchema);
  }
  return reversedLineups;
}

function setCurrentSquad(matchInfo, tId) {
  let team = null;
  if (matchInfo && matchInfo.homeTeam && matchInfo.homeTeam.teamId && String(matchInfo.homeTeam.teamId) === String(tId)) {
    team = matchInfo.homeTeam;
  }
  if (matchInfo && matchInfo.awayTeam && matchInfo.awayTeam.teamId && String(matchInfo.awayTeam.teamId) === String(tId)) {
    team = matchInfo.awayTeam;
  }
  if (team) {
    const { teamId, teamName, teamCode } = team;
    matchInfo.currentSquad = { teamId, teamName, teamCode };
  }
  return matchInfo;
}

export default function lineupsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_LINEUPS_SUCCESS:
      return {
        ...state,
        lineups: reverseAwayTeam(action.data),
      };
    case types.GET_LINEUPS_BASKET_SUCCESS:
      return {
        ...state,
        lineups: action.data,
      };
    case types.GET_LINEUPS_ERROR:
      return state;
    case types.GET_MATCHINFO_SUCCESS:
      return {
        ...state,
        matchInfo: setCurrentSquad(action.matchInfo, action.teamId),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/demo/reducers/lineups.js